import { Flex } from "@components/index";
import PopoverProvider from "./contexts/Details.provider";
import DetailsGanttProvider from "./contexts/DetailsGantt.provider";
import FilterProvider from "./contexts/Filter.provider";
import FiltersDrawerProvider from "./contexts/FiltersDrawer.provider";
import GanttDataProvider from "./contexts/GanttData.provider";
import Content from "./fragments/Content/Content.fragment";
import Details from "./fragments/Details/Details.fragment";
import DetailsGantt from "./fragments/DetailsGantt/DetailsGantt.fragment";
import FiltersDrawer from "./fragments/FiltersDrawer/FiltersDrawer.fragment";
import Header from "./fragments/Header/Header.fragment";

import styles from "./Dashboard.module.scss";

const DashboardPage: React.FC = () => {
  return (
    <FilterProvider>
      <FiltersDrawerProvider>
        <GanttDataProvider>
          <PopoverProvider>
            <DetailsGanttProvider>
              <Header />
              <Details />
              <DetailsGantt />
              <FiltersDrawer />
              <Flex className={styles.wrapper}>
                <Content />
              </Flex>
            </DetailsGanttProvider>
          </PopoverProvider>
        </GanttDataProvider>
      </FiltersDrawerProvider>
    </FilterProvider>
  );
}

export default DashboardPage;